import React from 'react';
import { PARTNERS } from '../data/mock';
import SectionHeading from './SectionHeading';

const Partners = () => {
  const stream = [...PARTNERS, ...PARTNERS];
  return (
    <section className="section-pad bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="Our Prestigious Partners"
          title="Worked at India's"
          accent="Finest"
          tail="Hotels & Venues"
        />

        <div className="mt-12 relative overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-cream to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-cream to-transparent z-10" />
          <div className="flex whitespace-nowrap animate-marquee-slow">
            {stream.map((p, i) => (
              <span
                key={i}
                className="mx-3 inline-flex items-center h-14 px-6 rounded-2xl bg-white border border-pink-100 text-stone-700 font-display font-semibold text-lg shadow-soft"
                data-testid={`partner-${p.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-${i}`}
              >
                {p}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
